import styled, { css } from 'styled-components';
import { FONTS, COLORS, SIZE, FONT_SIZE } from '@app/src/ui';
import { CATEGORY_ALIAS } from '@app/src/config/categories';

interface CalendarProps {
  isDayMonth: boolean;
  isDayOtherMonth: boolean;
  current: boolean;
  selected: boolean;
  isDisabled: boolean;
  categoryName: string;
}

interface ArrowProps {
  isDisabled: boolean;
}

const getLinearByCategory = (categoryName) => {
  switch(categoryName) {
    case CATEGORY_ALIAS.EMPLEO:
      return 'linear-gradient(180deg, #67B6F0 0%, #4890C5 100%)';
    case CATEGORY_ALIAS.INMUEBLE:
      return 'linear-gradient(180deg, #99CC33 0%, #6C9A0F 100%)';
    case CATEGORY_ALIAS.OPORTUNIDAD:
      return 'linear-gradient(180deg, #5A4B92 0%, #282048 100%)';
    case CATEGORY_ALIAS.VEHICULO:
      return 'linear-gradient(180deg, #D98A00 0%, #AD6E00 100%)';
    case CATEGORY_ALIAS.EDUCACION:
      return 'linear-gradient(180deg, #C3454C 0%, #911d24 100%)';
    default:
      break;
  }
}

export const MonthDays = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
  width: 280px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 427px;
  }
`;

export const Day = styled.div`
  display: flex;
  height: 32px;
  width: 32px;
  margin: 4px 4px;
  color: ${COLORS.BLACK};
  font-family: ${FONTS.OPEN_SANS};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 25px;
  border: 1px solid ${COLORS.GRAY_PLACEHOLDER};
  font-size: ${FONT_SIZE.SHORT};
  line-height: 16px;
  font-weight: bold;
  ${(props: CalendarProps) => props.isDayMonth && css`
    border: none;
  `};
  ${(props: CalendarProps) => props.isDayOtherMonth && css`
    border: none;
  `};
  ${(props: CalendarProps) => props.current && css`
    border: none;
    background-color: ${COLORS.GRAY_LIGHT};
    pointer-events: none;
  `};
  ${(props: CalendarProps) => props.selected && css`
    border: none;
    background-image: ${getLinearByCategory(props.categoryName)};
    color: #FFFFFF;
  `};
  ${(props: CalendarProps) => props.isDisabled && css`
    opacity: .3;
    pointer-events: none;
    border-radius: 22px;
  `};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 49px;
    width: 49px;
    font-size: 14px;
    margin: 6px 6px;
  }
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 21px;
`;

export const Month = styled.span`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
  color: ${COLORS.BLACK};
  padding: 0 56px;
`;

export const PrevArrow = styled.div`
  cursor: pointer;
  ${(props: ArrowProps) => props.isDisabled && css`
    pointer-events: none;
    opacity: .3;
  `};
`;

export const NextArrow = styled.div`
  transform: scaleX(-1);
  cursor: pointer;
  ${(props: ArrowProps) => props.isDisabled && css`
    pointer-events: none;
    opacity: .3;
  `};
`;
